import { FormHelperText } from "@mui/material";
import { FC } from "react";
import { Controller, useFormContext } from "react-hook-form";

import { ICustomField } from "@ryde/shared";

import { PassengerAddressBlock } from "./passenger-address.block";

export const PassengerAddressTemplate: FC<ICustomField> = ({
  name,
  formLabel,
  formAttributes,
}) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ fieldState: { error } }) => (
        <>
          <PassengerAddressBlock />
          {error && <FormHelperText>{error.message}</FormHelperText>}
        </>
      )}
    />
  );
};
